module.exports = __webpack_public_path__ + "static/integration/d2l/d2l.81fb7d4e073d705081323442a6c380a1.css";